export const RUNBOOKS_ROUTE_NAME = 'runbook'
export const RUNTASKS_ROUTE_NAME = 'runtask'
export const RUNBOOK_LABEL_ROUTE_NAME = 'runtask_label'

export const RUNBOOKS_LIST_DISPLAY_VIEWS = {
  LIST: 'list',
  WORKLOAD: 'workload',
  LABELS: 'labels',
}
export const RUNBOOK_DISPLAY_VIEWS = {
  GANTT: 'gantt',
  WORKLOAD: 'workload',
  PROOF_ENTRY: 'proof_entry',
  LIST: 'list',
}
